import { useEffect, useState } from 'react';

export const useCopyToClickBoard = ({ resetAfterMilSeconds } = { resetAfterMilSeconds: null }) => {
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!copied || !resetAfterMilSeconds || resetAfterMilSeconds < 0) return undefined;

        const timeoutId = setTimeout(() => setCopied(false), resetAfterMilSeconds);

        return () => clearTimeout(timeoutId);
    }, [copied, resetAfterMilSeconds]);

    const copyToClickBoard = async text => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
        } catch (err) {
            setCopied(false);
        }
    };

    return { copied, copyToClickBoard };
};
